import React from 'react'

const Header = () => {
  return (
    <div className='text-center mt-5 text-danger'>
        <h1>REVIEWS</h1>
    </div>
  )
}

export default Header